import { CollapseProps, default as MuiCollapse } from '@mui/material/Collapse'
import * as React from 'react'

type HTMLElementTagName = keyof HTMLElementTagNameMap
type CollapseRef = HTMLElementTagNameMap[HTMLElementTagName]

// eslint-disable-next-line no-shadow
export const Collapse = React.forwardRef<CollapseRef, CollapseProps>(function Collapse(props, ref) {
  return <MuiCollapse timeout="auto" {...props} ref={ref} />
})

export default Collapse
